import { render, staticRenderFns } from "./UserDashboardPets.vue?vue&type=template&id=0a4aa3b2&scoped=true&"
import script from "./UserDashboardPets.vue?vue&type=script&lang=js&"
export * from "./UserDashboardPets.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardPets.vue?vue&type=style&index=0&id=0a4aa3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4aa3b2",
  null
  
)

export default component.exports